import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, AppDispatch } from '../store';
import {HttpResponse} from "../../services/http.service";
import axios from "axios";
import {TagModel} from "../../models/tag.model";
import {PaginationModel} from "../../models/pagination.model";

const initialState: TagsSliceState = {
    tagsLoaded: false,
    tags: []
};

const tagsSlice = createSlice({
    name: 'tags',
    initialState,
    reducers: {
        setTags(state, action: PayloadAction<TagModel[]>) {
            state.tagsLoaded = true;
            state.tags = action.payload;
        }
    }
});

export const loadTags = (): AppThunk => async (dispatch: AppDispatch) => {
    const res: HttpResponse<PaginationModel<TagModel[]>> = await axios.get('tag/?offset=0&limit=-1');

    if (res) {
        dispatch(tagsSlice.actions.setTags(res.data.results.filter(tag => tag.tag_type === 'tag')));
    }
}

export default tagsSlice.reducer;

export interface TagsSliceState {
    tagsLoaded: boolean;
    tags: TagModel[];
}
